import * as React from 'react';
import { Select, useFieldState, SelectFieldProps, useFieldApi } from 'informed';
import { inputClasses } from '../validation/ValidationClasses';

interface DropdownProps extends SelectFieldProps<any, any>  {
    field: string;
    className?: string;
}

export const Dropdown = ({ field, className, ...props }: DropdownProps) => {
    const fieldState = useFieldState(field);
    const fieldApi = useFieldApi(field);

    return (<>
        <Select
            field={field}
            className={inputClasses(fieldApi.getError())}
            {...props}
        />
        {fieldApi.getError() ? (
            <span className="field-validation-error">{fieldApi.getError()}</span>
        ) : null}
    </>);
}
